export default __webpack_public_path__ + "static/media/ds3.6652c780.png";